import { Outlet } from 'react-router-dom'
import { cn } from '@/lib/utils'
import { FixturesBanner } from './FixturesBanner'
import { LeftNav } from './LeftNav'
import { ShellProvider, useShell } from './shell-context'
import { TopBar } from './TopBar'

function ShellLayout() {
  const { navOpen } = useShell()
  return (
    <div className="min-h-screen bg-canvas">
      <FixturesBanner />
      <TopBar />
      <LeftNav />
      <main className={cn('mt-14 px-6 pt-5 pb-12 transition-[margin]', navOpen ? 'ml-[220px]' : 'ml-[52px]')}>
        <Outlet />
      </main>
    </div>
  )
}

export function Shell() {
  return (
    <ShellProvider>
      <ShellLayout />
    </ShellProvider>
  )
}
